/**************************************************************************************************************************************************
*   MODULE NAME     :  UsersManagement
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  19-04-2021
*   DESCRIPTION     :  Component to load Users Management page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import {  FaSpinner } from 'react-icons/fa'
import { Row, Col, Button } from 'react-bootstrap';
import DataTable from '../common/dataTable/DataTable';
import {loadActiveInactiveUsersData} from "../../actions/userActions";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import { exportPDF } from '../common/ExportToPDF';

const UsersManagement = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    let usersList = props.usersActiveInactiveData;
  
    const columns = [
        {
            dataField: 'unique_val',
            text: 'unique_val',
            hidden: true,
            formatter: (cellContent, row) => {
                return `${row.systemId}, ${row.roleId}, ${row.japanUser}`
            }
        },
        {
            dataField: 'active',
            text: 'Status',
            sort: true,
            formatter: (cellContent, row) => {
                return row && !row.active ? 'Inactive' : 'Active'
            }
        },
        {
            dataField: 'systemId',
            text: 'System ID',
            sort: true,
            formatter: (cellContent, row) => {
                return row && row.systemId ? row.systemId : ''
            }
        },
        {
            dataField: 'firstName',
            text: 'User Name',
            sort: true,
            formatter: (cellContent, row) => {
                return row && row.firstName ? row.firstName +
                    " " + (row.lastName ? row.lastName : "") : ''
            }
        },
        {
            dataField: 'emailId',
            text: 'Email ID',
            sort: true,
            formatter: (cellContent, row) => {
                return row && row.emailId ? row.emailId : ''
            }
        },
        {
            dataField: 'role.masterDataValue',
            text: 'Role',
            sort: true,
            formatter: (cellContent, row) => {
                let role = row && row.role && row.role.masterDataValue ? row.role.masterDataValue : '';
                if(role === 'IT Administrator') return role;
                return `${row.japanUser ? 'Japan' : 'Global'} ${role}`
            }
        },
        {
            dataField: 'activationDate',
            text: 'Activation Date',
            sort: true,
            formatter: (cellContent, row) => {
                return row && row.activationDate ? ddmmmyyyyFormat(row.activationDate) : ''
            }
        },
        {
            dataField: 'deactivationDate',
            text: 'De-activation Date',
            sort: true,
            formatter: (cellContent, row) => {
                return row && !row.active && row.deactivationDate ? ddmmmyyyyFormat(row.deactivationDate) : ''
            }
        }]

    /****  
     * useEffect hook : Similar to componentDidMount and componentDidUpdate
     ****/
    useEffect(() => {
        getAllUsers();
    }, []);

    const getAllUsers = async () => {
        if (usersList && usersList.length > 0) return;
        setIsLoading(true);
        let response = await props.loadActiveInactiveUsersData();
        if (response && response.data && response.data.result) {
            let arr = response.data.result

            usersList = arr;
            setIsLoading(false)
        }

    }

    const exportFile = () => {

        var headers = [["Status", "System Id", "Name", "Email", "Role", "Activation Date", "Deactivation Date"]];
        var widths = [50, 70, 125, 205, 70, 100, 100]
        usersList.sort((a, b) => ((a["firstName"] +" "+ a["lastName"]) > (b["firstName"] +" "+ b["lastName"])) ? 1 : -1)

        const data = usersList.map(elt => {
            let status = elt.active === false ? 'Inactive' : 'Active'
            let element = [status, elt["systemId"], elt["firstName"] +" "+ elt["lastName"], elt["emailId"], elt["role"]["masterDataValue"]]
            let actDate = elt["activationDate"] ?ddmmmyyyyFormat(elt["activationDate"]) : " ";
            element.push(actDate);
            let deactivationVal = elt.active == false && elt["deactivationDate"] ? ddmmmyyyyFormat(elt["deactivationDate"]) : " ";
            element.push(deactivationVal)
            return element;
        }
        )
        
        exportPDF("User Details", "", headers, data, widths, "")
    }


    return (
        <div className="pt-1 savedSearchList pl-4 pr-4">
            <Row>
                <Col className="btns text-right">

                    <Button
                        variant="primary"
                        type="submit"
                        className="mr-2 btn btn-primary"
                        onClick={() =>
                            exportFile()
                        }
                    >
                        Print All
                        </Button>
                </Col>
            </Row>
            <DataTable
                keyField="unique_val"
                defaultSortField= "firstName"
                sortOrder = "asc"
                data={usersList}
                columns={columns}

            />
            {isLoading && (
                <div className="loader">
                    <FaSpinner />
                </div>
            )}
        </div>

    );
}


const mapStateToProps = state => {
    return {

        usersActiveInactiveData: state.userDataReducer.usersActiveInactiveData,

    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            loadActiveInactiveUsersData

        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersManagement));
